/**
 * Режим открытия глобального поиска (Header + GlobalSearch).
 * - hotkey: только Ctrl/Cmd+K (и клик по строке)
 * - type: открытие при начале ввода / сканере (когда фокус не в поле)
 *
 * SSOT: localStorage + CustomEvent для синхронизации Header ↔ GlobalSearch.
 */

export const GLOBAL_SEARCH_ACTIVATION_KEY = 'markbase.globalSearch.activationMode';
export const GLOBAL_SEARCH_ACTIVATION_EVENT = 'GLOBAL_SEARCH_ACTIVATION_CHANGE';

export const GLOBAL_SEARCH_ACTIVATION = Object.freeze({
  HOTKEY: 'hotkey',
  TYPE: 'type',
});

/** По умолчанию — ввод (сканер штрихкодов и прежнее поведение type-to-search). */
const DEFAULT_MODE = GLOBAL_SEARCH_ACTIVATION.TYPE;

export function normalizeGlobalSearchActivationMode(value) {
  return value === GLOBAL_SEARCH_ACTIVATION.HOTKEY
    ? GLOBAL_SEARCH_ACTIVATION.HOTKEY
    : GLOBAL_SEARCH_ACTIVATION.TYPE;
}

export function getGlobalSearchActivationMode() {
  try {
    return normalizeGlobalSearchActivationMode(localStorage.getItem(GLOBAL_SEARCH_ACTIVATION_KEY));
  } catch {
    return DEFAULT_MODE;
  }
}

export function setGlobalSearchActivationMode(mode) {
  const next = normalizeGlobalSearchActivationMode(mode);
  try {
    localStorage.setItem(GLOBAL_SEARCH_ACTIVATION_KEY, next);
  } catch {
    /* private mode */
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent(GLOBAL_SEARCH_ACTIVATION_EVENT, { detail: { mode: next } }),
    );
  }
  return next;
}
